import { z } from "zod";
import { ShortText, idString } from "./common.js";
/**
 * Goals — the VSM charter's baseline → target → % change table (VSM-WS10,
 * PB-347). Each row names one metric with a baseline and a target; the
 * % change is DERIVED by the renderer, never stored. `baseline`/`target` are
 * nullable so a freshly-added row (no numbers yet) is representable; `.finite()`
 * keeps NaN/Infinity out of the persisted params. Rendered data-blind by the DS
 * `GoalsWidget` and embedded by the VSM charter (canvas placement + AI drafting
 * land later, per the `sipoc` precedent).
 */
const GoalRow = z
    .object({
    id: idString,
    metric: ShortText,
    baseline: z.number().finite().nullable(),
    target: z.number().finite().nullable(),
    unit: ShortText,
})
    .strict();
export const GoalsParamsSchema = z
    .object({
    rows: z.array(GoalRow).max(50),
})
    .strict();
export const defaultGoalsParams = {
    rows: [],
};
//# sourceMappingURL=goals.js.map